import React, { useEffect, useState } from 'react';
import { HeaderFull, IUser } from '@quantum/ui-organisms';
import { logger } from '@quantum/utils';
import { useCart, useSession } from '@quantum/ui-core';
import { ACCOUNT_LOGIN, ACCOUNT_ACTIVATE, CART_LINK } from '@/constants';

interface HeaderProps {
  locale: string;
}

export const Header = ({ locale }: HeaderProps): JSX.Element => {
  const [isSearchModeOn, setIsSearchModeOn] = useState<boolean>(false);
  const [searchKeyword, setSearchKeyword] = useState<string>('');
  const [user, setUser] = useState<IUser>({ sessionState: 'unknown' });
  const [cart] = useCart();
  const { sessionState, logUserOut } = useSession();
  const numberOfCartItems = cart.data?.totalItemQuantity || 0;

  useEffect(() => {
    setUser({ sessionState });
  }, [sessionState]);

  if (cart.error) {
    logger.error(cart.error);
  }

  const clearSearch = (): void => {
    setSearchKeyword('');
    setIsSearchModeOn(false);
  };

  return (
    <HeaderFull
      isSearchModeOn={isSearchModeOn}
      onOpenSearchMode={(): void => setIsSearchModeOn(true)}
      onCloseSearchMode={(): void => clearSearch()}
      numberOfCartItems={numberOfCartItems}
      onSearchChange={(keyword: string): void => setSearchKeyword(keyword)}
      searchKeyword={searchKeyword}
      activateLink={ACCOUNT_ACTIVATE}
      loginLink={ACCOUNT_LOGIN}
      user={user}
      cartLink={CART_LINK}
      locale={locale}
      logUserOut={logUserOut}
    />
  );
};
